import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';

import { useUserDataStore } from '../store';
import type { ResDataSoliq } from '../types';
import { notification } from 'antd';

interface APIResponse<T> {
  data: string | T;
  success: boolean;
}

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_SOLIQ_BASE_URL || '',
});

httpClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { soliqAccessToken, accessToken } = useUserDataStore.getState();
  if (soliqAccessToken) {
    config.headers['Authorization'] = accessToken ? `Bearer ${accessToken}` : '';
    config.headers['token'] = soliqAccessToken ? `${soliqAccessToken}` : '';
  }

  config.headers['lang'] = 'uz';

  if (!config.url) return config;

  if (config.params) {
    const entries = Object.entries(config.params);
    const filteredEntries = entries.filter(([_, value]) => value !== '' && value !== undefined && value !== null);
    config.params = Object.fromEntries(filteredEntries);
  }

  return config;
});
httpClient.interceptors.response.use(
  (response: AxiosResponse<ResDataSoliq<any>>) => {
    if (response.data.status === 'UNAUTHORIZED') {
      notification.error({ message: 'SOLIQ', description: response.data.data });
    }
    return {
      ...response,
      data: {
        data: response.data,
        success: true,
      } as APIResponse<ResDataSoliq>,
    };
  },
  (error) => {
    return Promise.resolve({
      data: {
        ...error.response.data,
        success: false,
      } as APIResponse<any>,
    });
  }
);

export const APISoliq = httpClient;
